import React, { useContext, useEffect, useState } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import useExtendedDeviation from '../../../../../utils/hooks/useExtendedDeviation';
import BoostNoCoreModal from '../BoostNoCoreModal';
import BoostUpgradeCoreModal from '../BoostUpgradeCoreModal';
import BoostModal from '../BoostModal';
import BoostSuccessModal from '../BoostSuccessModal';
import AlreadyBoostedModal from '../AlreadyBoostedModal';
import BoostNotSupportedModal from '../BoostNotSupportedModal';
const BoostRootModal = ({ deviation: deviationFromProps, onRequestClose })=>{
    var _deviation_extended, _deviation_extended1;
    const [showingModal, setShowingModal] = useState('loading');
    const [wasJustBoosted, setWasJustBoosted] = useState(false);
    const onSuccess = ()=>setWasJustBoosted(true);
    const { hasCoreMembership, coreLevel } = useContext(SessionContext);
    const deviation = useExtendedDeviation(deviationFromProps) || deviationFromProps;
    const isDeviationExtended = !!deviation.extended;
    const isBoosted = !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.boosted);
    const isBoostable = !!((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.isBoostable);
    useEffect(()=>{
        let showModalType = 'boost';
        if (!hasCoreMembership) {
            showModalType = 'no-core';
        } else if (coreLevel === 'core_access') {
            showModalType = 'upgrade-core';
        } else {
            if (!isDeviationExtended) {
                showModalType = 'loading';
            } else {
                if (isBoosted) {
                    if (wasJustBoosted) {
                        showModalType = 'success';
                    } else {
                        showModalType = 'already-boosted';
                    }
                } else if (!isBoostable) {
                    showModalType = 'not-boostable';
                }
            }
        }
        setShowingModal(showModalType);
    }, [
        showingModal,
        isDeviationExtended,
        isBoostable,
        isBoosted,
        wasJustBoosted,
        hasCoreMembership,
        coreLevel,
        deviation.deviationId
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showingModal === 'loading' && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        usePortal: true,
        withOverlay: true
    }), showingModal === 'no-core' && /*#__PURE__*/ React.createElement(BoostNoCoreModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'upgrade-core' && /*#__PURE__*/ React.createElement(BoostUpgradeCoreModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'boost' && /*#__PURE__*/ React.createElement(BoostModal, {
        deviation: deviation,
        onSuccess: onSuccess,
        onRequestClose: onRequestClose
    }), showingModal === 'success' && /*#__PURE__*/ React.createElement(BoostSuccessModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'already-boosted' && /*#__PURE__*/ React.createElement(AlreadyBoostedModal, {
        onRequestClose: onRequestClose
    }), showingModal === 'not-boostable' && /*#__PURE__*/ React.createElement(BoostNotSupportedModal, {
        onRequestClose: onRequestClose
    }));
};
BoostRootModal.displayName = 'BoostRootModal';
export default BoostRootModal;

//# sourceMappingURL=BoostRootModal.js.map